/* eslint-disable import/no-anonymous-default-export */

// useful functions in one place
export default /* glsl */`

vec3 desaturate(in vec3 value, in float factor){
  vec3 gray = vec3( dot( value , vec3( 0.2126 , 0.7152 , 0.0722 ) ) );
  return vec3(mix(value, gray, factor));
}

// helper to convert vectors from -1 to 1 into 0 to 1
vec3 visualizeVector(in vec3 vector){
  return vector * 1.0 + vec3(1.0);
}

// this will use an explicit tangent, useful for flipping aniso direction for some effects
vec3 getAnisotropizedNormalExplicit(in vec3 normal, in vec3 tangent, in vec3 viewDir, in float strength){ 
  // see how perpendicular we are to the tangent direction
  float dotTV = dot(viewDir, tangent);
  float dotSample = pow(dotTV, 3.0);
  vec3 anisoAdjustedNormal = mix(normal, tangent, min(dotSample * strength, 1.0));
  //vec3 anisoAdjustedNormal = mix(debug1, debug2, dotSample);
  return anisoAdjustedNormal;
}

// skews the normal towards the anisotropy direction based on viewing angle
vec3 getAnisotropizedNormal(in vec3 normal, in vec3 tangent, in vec3 viewDir, in float strength){ 
  vec3 debug1 = vec3(1.0, 0.0, 0.0);
  vec3 debug2 = vec3(0.0, 1.0, 0.0);
  vec3 antiTangent = reflect(-tangent, normal);
  vec3 closerTangent = vec3(0.0);
  if (distance(viewDir, antiTangent) < distance(viewDir, tangent)){
      closerTangent = antiTangent;
  } else {
      closerTangent = tangent;
  }
  vec3 anisoAdjustedNormal = getAnisotropizedNormalExplicit(normal, closerTangent, viewDir, strength);
  //vec3 anisoAdjustedNormal = mix(debug1, debug2, dotSample);
  return anisoAdjustedNormal;
}

vec3 getLightAnisotropyNormal(in vec3 lightDir, in vec3 normal, in vec3 tangent, in vec3 viewDir, in float strength){
  vec3 debug1 = vec3(1.0, 0.0, 0.0);
  vec3 debug2 = vec3(0.0, 1.0, 0.0);

  vec3 maskDir = normalize( lightDir + viewDir * (magic3 - 1.0));

  //vec3 anisoNormal = getAnisotropizedNormal(normal, tangent, viewDir, strength);
  vec3 viewReflect = reflect(-viewDir, normal);
  float dotVRL = dot(viewReflect, lightDir);
  float dotMask = dot(viewReflect, maskDir);
  //float dotNL = dot(normal, lightDir);
  float mainFactor = 10.0 * magic1;
  float maskFactor = 11.0 * magic2;
  float adjustedVRL = saturate(-mainFactor + (mainFactor + 1.0) * dotVRL);
  float adjustedMask = saturate(-maskFactor + (maskFactor + 1.0) * dotMask);
  float dotNV = dot(normal, viewDir);

  //float maskedDot = mix()
  
  return mix(debug1 * adjustedVRL, debug2 * adjustedMask, 0.5);
  //return visualizeVector(anisoNormal);
  //return anisoNormal;
}

`;